<template>
  <v-container full-height
               fluid
               class="pa-0">
    <v-row class="full-height"
           v-if="this.$store.getters.paddocks"
           no-gutters>
      <v-col cols="12"
             class="full-height">
        <v-row class="full-height"
               no-gutters>
          <!-- inicio de sidebar -->
          <v-col cols="2"
                 class="smartbell-sidebar pa-0 full-height">
          </v-col>
          <!-- fin de sidebar -->
          <!-- inicio de contenedor principal -->
          <v-dialog v-model="dialogHst"
                    class="std-background-white-1"
                    width="30%">
            <v-row no-gutters>
              <v-col cols="12"
                     class="d-flex align-center justify-center std-background-blue-2 font-weight-medium std-text-white-1 "
                     style="height:40px">{{getEventType(hstToShow.type)}}
              </v-col>
              <v-row no-gutters class="std-background-white-1">
                <v-col cols="12" class="d-flex justify-center flex-wrap"
                       style="position: relative">
                  <div class="col-4 std-text-blue-2 font-weight-medium">Evento: </div>
                  <div class="col-6 std-text-gray-3 std-text-sm">{{hstToShow.name}}</div>
                  <div class="col-10 pa-0"
                       style="height: 1px; background-color: lightgray; position: absolute; bottom: 0">
                  </div>
                </v-col>
                <v-col cols="12" class="d-flex justify-center flex-wrap"
                       style="position: relative">
                  <div class="col-4 std-text-blue-2 font-weight-medium">Fecha: </div>
                  <div class="col-6 std-text-gray-3 std-text-sm">{{hstToShow.date}}</div>
                  <div class="col-10 pa-0"
                       style="height: 1px; background-color: lightgray; position: absolute; bottom: 0px">
                  </div>
                </v-col>
                <v-col cols="12" class="d-flex justify-center flex-wrap">
                  <div class="col-4 std-text-blue-2 font-weight-medium">Descripción:</div>
                  <div class="col-6 std-text-gray-3 std-text-sm">{{hstToShow.description}}</div>
                </v-col>
              </v-row>
              <v-col cols="12"
                     v-ripple
                     @click="dialogHst = false"
                     class="d-flex align-center justify-center std-text-xs
                     unselectable
                      std-background-grey-1 font-weight-medium std-text-blue-1"
                     style="height: 30px; cursor: pointer; border-top: 1px lightgray solid">Cerrar
              </v-col>
            </v-row>
          </v-dialog>
          <v-col cols="10"
                 class="full-height std-background-white-1">
            <!-- inicio de barra superior -->
            <v-row class="pl-6 pr-12 std-top-container mt-3 mb-4"
                   align="end"
                   justify="space-between"
                   no-gutters>
              <!-- inicio de botón de regresar -->
              <v-col cols="2" @click="back()">
                <BackButton></BackButton>
              </v-col>
              <!-- fin de botón de regresar -->
              <!-- inicio de tarjeta de vacas en sistema -->
              <v-col cols="3">
                <SystemCardCount height="40px"
                                 width="100%"
                                 :number="cowCount"
                                 title-background="#57A7F5"
                                 number-background="#1460AA"
                                 title="Vacas en sistema"></SystemCardCount>
              </v-col>
              <!-- fin de tarjeta de vacas en sistema -->
            </v-row>
            <!-- fin de barra superior -->

            <!--inicio de contenedor central -->
            <v-row class="std-container-lg py-0 ml-6 mr-11 std-background-white-1"
                   justify="center"
                   no-gutters>
              <v-snackbar
                      v-model="snackActive"
                      bottom
                      right
                      color="success">
                <v-progress-circular
                        size="24"
                        class="mr-2"
                        color="#FFFFFF"
                        :indeterminate="true"
                        width="4"
                ></v-progress-circular>
                {{snackText}}
                <v-btn dark
                       text
                       @click="snackbar = false">
                  Cerrar
                </v-btn>
              </v-snackbar>
              <Alerts :heat-ntn="htNtn"
                      :pt-check="ptNtn"
                      :bt-check="birthSwDisabled"
                      :health-active="hlNtn"
                      :current-sick="animalFire.health ? animalFire.health.sick : null"
                      :animal-key="id"
                      :id="animalFire.idInternal">
              </Alerts>
              <v-col cols="12" class="full-height">
                <v-row no-gutters
                        class="mb-2 full-height">
                  <!-- primera columna -->
                  <v-col cols="5"
                         class="pr-3">
                    <v-row no-gutters>
                      <v-col cols="12"
                             class="mb-2 cp-top-individual-container">
                        <v-row class="full-height"
                               no-gutters>
                          <v-col cols="12"
                                 class="cp-control-text-container">
                            <v-row no-gutters
                                   class="full-height">
                              <v-col cols="2"
                                     class="pr-2">
                                <div class="d-flex justify-center align-center flex-wrap full-height pt-2 cp-border-item std-background-grey-1">
                                  <div class="col-12 pa-0 d-flex align-center justify-center">
                                    <i class="cp-id-icon mb-1"></i>
                                  </div>
                                  <div class="col-12 pa-0 d-flex align-center justify-center">
                                    <div class="std-text-md-open std-text-gray-3">{{idResized(animalFire.idInternal)}}</div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="10"
                                     class="pl-2">
                                <div class="full-height d-flex align-center justify-start flex-wrap pl-2 cp-border-item unselectable std-background-grey-1">
                                  <div class="col-12 pa-0 pt-2 std-text-md std-text-blue-2"><b>Parto</b> estimado entre los días</div>
                                  <div class="col-12 pa-0 pb-2 std-text-md std-text-red-1">01 al 04 de septiembre del 2020</div>
                                </div>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12"
                                 class="cp-control-container">
                            <v-row no-gutters
                                   class="full-height">
                              <v-col col="6"
                                     class="pr-3"
                                     style="background-color: white">
                                <v-row no-gutters class="full-height">
                                  <v-col cols="12"
                                         style="height: 32px; "
                                         class="mt-2 d-flex align-center justify-center std-text-md std-text-blue-2 font-weight-bold">
                                    Potrero
                                  </v-col>
                                  <v-col cols="12"
                                         style="height: 216px">
                                    <v-select outlined
                                              class="pt-1 pb-2"
                                              dense
                                              hide-selected
                                              v-model="paddock"
                                              @change="setPaddock()"
                                              item-value="name"
                                              :items="paddocks"
                                              item-text="name"
                                              hide-details>
                                    </v-select>
                                    <div style="height: 164px; border-radius: 4px; max-width: 100%"
                                         class="d-flex flex-wrap">
                                      <v-img class="std-border-radius std-container-shadow-dense"
                                             height="100%"
                                             width="192px"
                                             src="https://staticmer.emol.cl/Fotos/2013/11/04/file_20131104162322.jpg">
                                      </v-img>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col col="6"
                                     class="pl-3">
                                <v-row no-gutters class="full-height">
                                  <v-col cols="12"
                                         style="height: 32px"
                                         @click="vaccinesRegistryOn"
                                         class="mt-2 text-center std-text-md std-text-blue-2 font-weight-bold">
                                    Alertas o eventos
                                  </v-col>
                                  <v-col cols="12"
                                         class="cp-switch-container">
                                    <v-row no-gutters
                                           class="full-height">
                                      <v-tooltip left
                                                 color="#EB004E">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-col cols="12"
                                                 @click="openSpecificAlert('Heat')"
                                                 v-bind="attrs"
                                                 v-on="on"
                                                 :class="{'std-disabled' : !htNtn}"
                                                 class="mb-1 std-border-radius std-container-shadow-dense
                                                 cp-card-switch-container std-background-red-1">
                                            <v-row no-gutters
                                                   class="full-height">
                                              <v-col cols="3"
                                                     class="d-flex align-center justify-center std-border-left-radius">
                                                <v-icon class="cp-heat-icon">
                                                </v-icon>
                                              </v-col>
                                              <v-col cols="6"
                                                     class="d-flex cp-switch-text std-text-white-1 align-center pl-1">
                                                Celo
                                              </v-col>
                                              <v-col cols="3"
                                                     class="justify-center align-center d-flex">
                                                <v-fade-transition>
                                                  <v-icon color="#FFFFFF"
                                                          v-if="htNtn"
                                                          size="30px"
                                                          dense>notification_important
                                                  </v-icon>
                                                  <v-icon color="#FFFFFF"
                                                          v-if="ptCheck"
                                                          size="30px"
                                                          dense>check_circle
                                                  </v-icon>
                                                </v-fade-transition>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                        </template>
                                        <span>{{ this.htToolText }}</span>
                                      </v-tooltip>
                                      <v-tooltip left
                                                 color="#EB004E">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-col cols="12"
                                                 @click="openSpecificAlert('Gestation')"
                                                 v-bind="attrs"
                                                 v-on="on"
                                                 :class="{'std-disabled' : !ptNtn}"
                                                 class="mb-1 std-border-radius std-container-shadow-dense cp-card-switch-container">
                                            <v-row no-gutters
                                                   class="full-height std-background-blue-2 std-border-radius">
                                              <v-col cols="3"
                                                     class="d-flex align-center justify-center std-border-left-radius">
                                                <v-icon class="cp-pregnant-icon">
                                                </v-icon>
                                              </v-col>
                                              <v-col cols="6"
                                                     class="d-flex cp-switch-text std-text-white-1 align-center pl-1">
                                                Preñada
                                              </v-col>
                                              <v-col cols="3"
                                                     class="justify-center align-center d-flex">
                                                <v-icon color="#EB004E"
                                                        v-if="ptNtn"
                                                        size="30px"
                                                        dense>notification_important
                                                </v-icon>
                                                <v-icon color="#65D9AC"
                                                        v-if="ptCheck"
                                                        size="30px"
                                                        dense>check_circle
                                                </v-icon>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                        </template>
                                        <span>{{ ptToolText }}</span>
                                      </v-tooltip>
                                      <v-tooltip left
                                                 color="#EB004E">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-col cols="12"
                                                 v-bind="attrs"
                                                 @click="openSpecificAlert('Birth')"
                                                 v-on="on"
                                                 :class="{'std-disabled' : !btNtn}"
                                                 class="mb-1 std-border-radius std-container-shadow-dense cp-card-switch-container">
                                            <v-row no-gutters
                                                   class="full-height std-background-blue-3 std-border-radius">
                                              <v-col cols="3"
                                                     class="d-flex align-center justify-center std-border-left-radius">
                                                <v-icon class="cp-calf-icon">
                                                </v-icon>
                                              </v-col>
                                              <v-col cols="6"
                                                     class="d-flex cp-switch-text std-text-white-1 align-center pl-1">
                                                Parto
                                              </v-col>
                                              <v-col cols="3"
                                                     class="justify-center align-center d-flex">
                                                <v-icon color="#EB004E"
                                                        v-if="btNtn"
                                                        size="30px"
                                                        dense>notification_important
                                                </v-icon>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                        </template>
                                        <span>{{btToolText}}</span>
                                      </v-tooltip>
                                      <v-tooltip left
                                                 color="#EB004E">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-col cols="12"
                                                 @click="openSpecificAlert('Health')"
                                                 class="std-border-radius std-background-green-1 std-container-shadow-dense cp-card-switch-container">
                                            <v-row no-gutters
                                                   class="full-height">
                                              <v-col cols="3"
                                                     class="d-flex align-center justify-center std-border-left-radius">
                                                <v-icon class="cp-sick-icon">
                                                </v-icon>
                                              </v-col>
                                              <v-col cols="6"
                                                     class="d-flex std-text-white-1 cp-switch-text align-center pl-1">
                                                Salud
                                              </v-col>
                                              <v-col cols="3"
                                                     class="justify-center align-center d-flex">
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                        </template>
                                        <span></span>
                                      </v-tooltip>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12"
                             class="mb-3">
                        <v-row class="full-height" no-gutters>
                          <v-col cols="12"
                                 style="position: relative"
                                 class="mb-1 cp-card-header-container justify-center std-text-md std-text-blue-2 font-weight-bold d-flex align-center ">
                            Datos generales
                            <div style="position: absolute; right: 4px; cursor: pointer;"
                                 class="std-text-xs std-text-blue-2 font-weight-regular std-text-underline">
                                 Genealogía
                            </div>
                          </v-col>
                          <v-col cols="12"
                                 class="cp-data-card-container std-border-radius std-container-shadow std-background-white-1">
                            <v-row no-gutters class="full-height">
                              <!-- inicio raza y etapa reproductiva -->
                              <v-col cols="12"
                                     class="cp-data-card-row std-border-top-radius">
                                <v-row no-gutters class="full-height">
                                  <v-col cols="6" class="d-flex align-center flex-wrap pl-3">
                                    <div class="col-12 pa-0 std-text-md std-text-blue-2">Raza</div>
                                    <div class="col-12 pa-0 cp-switch-text font-weight-bold std-text-gray-3">{{animalFire.breed}}</div>
                                  </v-col>
                                  <v-col cols="6" class="d-flex align-center flex-wrap pl-3">
                                    <div class="col-12 pa-0 std-text-md std-text-blue-2">Etapa reproductiva</div>
                                    <div class="col-12 pa-0 cp-switch-text font-weight-bold std-text-gray-3">Gestante</div>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <!-- fin raza y etapa reproductiva -->
                              <!-- inicio fecha de nacimiento estado de lactancia -->
                              <v-col cols="12"
                                     class="cp-data-card-row">
                                <v-row no-gutters class="full-height">
                                  <v-col cols="6" class="d-flex align-center flex-wrap pl-3">
                                    <div class="col-12 pa-0 std-text-md std-text-blue-2">Fecha de nacimiento</div>
                                    <div class="col-12 pa-0 cp-switch-text font-weight-bold std-text-gray-3">{{formattedDate(animalFire.birthday)}}</div>
                                  </v-col>
                                  <v-col cols="6" class="d-flex align-center flex-wrap pl-3">
                                    <div class="col-12 pa-0 std-text-md std-text-blue-2">Estado de lactancia</div>
                                    <div class="col-12 pa-0 cp-switch-text font-weight-bold std-text-gray-3">
                                      {{animalFire.state}}</div>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <!-- fin fecha de nacimiento estado de lactancia -->
                              <!-- inicio de último parto, dim y lactancia -->
                              <v-col cols="12"
                                     class="cp-data-card-row">
                                <v-row no-gutters class="full-height">
                                  <v-col cols="6" class="d-flex align-center flex-wrap pl-3">
                                    <div class="col-12 pa-0 std-text-md std-text-blue-2">Último parto</div>
                                    <div class="col-12 pa-0 cp-switch-text font-weight-bold std-text-gray-3">
                                      {{ animalFire.calving ? formattedDate(animalFire.calving.date ) : 'No disponible'}}</div>
                                  </v-col>
                                  <v-col cols="6" class="d-flex align-center flex-wrap pl-3">
                                    <v-row no-gutters class="full-height">
                                      <v-col cols="4" class="d-flex align-center flex-wrap">
                                        <div class="col-12 pa-0 std-text-md std-text-blue-2">DIM</div>
                                        <div class="col-12 pa-0 cp-switch-text font-weight-bold std-text-gray-3 ">
                                          {{ animalFire.calvingInfo ? animalFire.dim : 'N/A'}}
                                        </div>
                                      </v-col>
                                      <v-col cols="8" class="d-flex align-center flex-wrap text-center">
                                        <div class="col-12 pa-0 std-text-md std-text-blue-2"># Lactancia</div>
                                        <div class="col-12 pa-0 cp-switch-text font-weight-bold std-text-gray-3">{{animalFire.lactationCycle}}</div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <!--fin de último parto, dim y lactancia -->
                              <!-- inicio ID SINIIGA y botón baja de ganado -->
                              <v-col cols="12"
                                     class="cp-data-card-row std-border-bottom-radius"
                                     style="margin-bottom: 0">
                                <v-row no-gutters class="full-height">
                                  <v-col cols="6" class="d-flex align-center flex-wrap pl-3">
                                    <div class="col-12 pa-0 std-text-md std-text-blue-2">ID SINIIGA</div>
                                    <div class="col-12 pa-0 font-weight-bold std-text-gray-3 std-text-xs">
                                      {{'MX-00-00-' + animalFire.idSiniiga}}</div>
                                  </v-col>
                                  <v-col cols="6" class="d-flex align-center flex-wrap px-3">
                                    <v-btn height="48px"
                                           @click="openSpecificAlert('Delete')"
                                           class="std-btn-delete"
                                           depressed
                                           block>
                                      <i class="std-icon std-delete-icon mr-2">
                                      </i>Baja de ganado</v-btn>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <!-- fin ID SINIIGA y botón baja de ganado -->
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- fin de primera columna -->

                  <!-- segunda columna -->
                  <v-col cols="7"
                         class="pl-2">
                    <v-row no-gutters
                           class="full-height">
                      <!-- inicio monitor de actividad -->
                      <v-col cols="12"
                             v-if="!historyExpanded"
                             class="mb-2 cp-top-individual-container px-1">
                        <v-row no-gutters class="full-height" style="overflow-y: auto">
                          <v-col cols="12">
                          </v-col>
                          <v-col cols="12"
                                 style="height: 32px"
                                 class="mt-2 d-flex align-center justify-center std-text-md std-text-blue-2 font-weight-bold">
                            Monitor de actividad
                          </v-col>
                          <v-col cols="12"
                                 class="d-flex flex-wrap"
                                 style="height: 288px">
                            <v-img max-height="288px"
                                   class="d-flex justify-center cp-border-item"
                                   src="https://www.happyhourspanish.com/wp-content/uploads/2012/05/animals-vaca-e1350094369988.jpg">
                              <div class="col-12 pa-0 d-flex full-height">
                                <div class="col-5 pa-0 d-flex align-center justify-center">
                                  <div style="height: 166px; width: 166px">
                                    <v-img src="../assets/cow-profile/cow.svg">
                                    </v-img>
                                  </div>
                                </div>
                                <div class="col-7 pa-0 d-flex align-center">
                                  <div style="height: 166px; max-width: 350px;" class="mr-8 text-center">
                                    <div class="cp-switch-text std-text-white-1 font-weight-bold mb-2">Conoce con mayor precisión a tus vacas</div>
                                    <div class="std-text-white-1 mb-2">Collar y arete inteligentes disponibles próximamente.</div>
                                    <v-btn height="40px"
                                           class="std-btn-delete elevation-3"
                                           depressed>
                                      <div class="std-text-xs">Registrarme en la lista de espera</div></v-btn>
                                  </div>
                                </div>
                              </div>
                            </v-img>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- fin monitor de actividad -->

                      <!-- inicio bitácora de eventos -->
                      <v-col cols="12"
                             class="px-1 mb-3"
                             :class="[{'cp-bottom-individual-container': !historyExpanded}, {'cp-full-column-container': historyExpanded}]">
                        <v-row class="full-height"
                               no-gutters>

                          <v-col cols="12"
                                 style="position: relative"
                                 class="mb-1 px-1 cp-card-header-container justify-center std-text-md std-text-blue-2 font-weight-bold d-flex align-center">
                            Bitácora de eventos
                            <div style="position: absolute; right: 8px; cursor: pointer;"
                                 class="std-text-xs std-text-blue-2 font-weight-regular std-text-underline"
                                 @click="resizeHistory()">{{ historyResizeTitle }}</div>
                          </v-col>

                          <!-- inicio tarjetas superiores -->
                          <v-col cols="12"
                                 class="mb-2"
                                 v-if="historyExpanded"
                                 style="height: 40px">
                            <v-row no-gutters
                                   class="full-height justify-space-between std-text-white-1 font-weight-bold std-text-xs">
                              <v-col cols="5"
                                     @click="eventsOn()"
                                     style="position: relative"
                                     class="d-flex align-center justify-start std-container-shadow-dense
                                     std-background-blue-2 std-border-radius"
                                     :class="{ 'cp-tab-inactive' : vaccineSelected }">
                                <div class="pl-4">Listado de eventos</div>
                                <i class="std-icon cp-calendar-icon" style="position: absolute; right: 32px"></i>
                              </v-col>
                              <v-col cols="5"
                                     @click="vaccinesOn()"
                                     style="position: relative"
                                     class="d-flex align-center justify-start std-container-shadow-dense
                                     std-background-blue-2 std-border-radius"
                                     :class="{ 'cp-tab-inactive' : listSelected }">
                                <div class="pl-4">Vacunación y desarrollo</div>
                                <i class="std-icon cp-vaccine-icon" style="position: absolute; right: 32px"></i>
                              </v-col>
                            </v-row>
                          </v-col>
                          <!-- fin tarjetas superiores -->

                          <!-- inicio listado de eventos -->
                          <v-col cols="12"
                                 v-if="listSelected && !weightSelected"
                                 :class="[{'cp-table-container': !historyExpanded}, {'cp-table-full-container': historyExpanded}]">

                            <!-- inicio de header de tabla -->
                            <v-row no-gutters
                                   class="px-1 font-weight-medium std-text-md-open"
                                   cols="12">
                              <div class="std-table-header d-flex align-center justify-center col-12">
                                <div class="std-text-md-open col-3 d-flex align-center justify-center pa-0 ">
                                  Tipo
                                  <i class="std-vertical-arrow-icon"
                                     @click="orderBy('type', tpOrderFlag)"
                                     :class="{'icon-anim' : tpSortedIcon}"
                                     @animationend="tpSortedIcon = false">
                                  </i>
                                </div>
                                <div class=" col-2 d-flex justify-center align-center pa-0">
                                  Fecha
                                  <i class="std-vertical-arrow-icon"
                                     @click="orderBy('date', dtOrderFlag)"
                                     :class="{'icon-anim' : dtSortedIcon}"
                                     @animationend="dtSortedIcon = false">
                                  </i>
                                </div>
                                <div class="  col-4 d-flex justify-center align-center pa-0">
                                  Evento
                                  <i class="std-vertical-arrow-icon"
                                     @click="orderBy('description', evOrderFlag)"
                                     :class="{'icon-anim' : evSortedIcon}"
                                     @animationend="evSortedIcon = false">
                                  </i>
                                </div>
                                <div class="col-3 d-flex justify-center align-center pa-0">
                                  Acciones
                                </div>
                              </div>
                            </v-row>
                            <!-- fin de header de tabla -->

                            <!-- inicio de contenido de tabla -->
                            <v-row no-gutters
                                   class="px-1"
                                   v-if="croppedHst.length !== 0"
                                   :class="[{'cp-table-rows-container': !historyExpanded}, {'cp-table-rows-full-container': historyExpanded}]"
                                   align-content="start">
                              <v-fade-transition v-for="(item, index) in croppedHst"
                                                 group
                                                 style="width: 100%"
                                                 :key="index">
                                <v-col cols="12"
                                       class="d-flex align-center justify-center std-table-row-container pa-0 std-pointer unselectable"
                                       :key="index"
                                       v-ripple
                                       @click="showHstItem(item)"
                                       :class="[{'first-row' : index === 0}]">
                                  <div class="col-3 align-center justify-center std-text-sm-open std-text-gray-3 pa-0 d-flex text-center" >
                                    {{getEventType(item.type)}}
                                  </div>
                                  <div class="col-2 d-flex align-center justify-center std-text-sm-open std-text-gray-3 pa-0 text-center">
                                    {{item.date}}
                                  </div>
                                  <!-- tercer campo -->
                                  <div class="col-4 d-flex align-center justify-center std-text-sm-open std-text-gray-3 pa-0 text-center">
                                    {{item.name}}
                                  </div>
                                  <!-- fin de cuarto campo -->
                                  <div class="col-3 d-flex align-center justify-center std-text-sm-open std-text-gray-3 pa-0">
                                    <div class="d-inline-flex mx-2">
                                      <button class="ds-arrows std-delete"
                                              type="button"
                                              v-if="item.type !== 'preg' ? true : item.date === animalFire.pregDate"
                                              @click.stop="openSpecificAlert('evt', item.key)"></button>
                                    </div>
                                  </div>
                                </v-col>
                              </v-fade-transition>
                            </v-row>
                            <v-row no-gutters
                                   class="px-1"
                                   v-else
                                   :class="[{'cp-table-rows-container': !historyExpanded}, {'cp-table-rows-full-container': historyExpanded}]"
                                   align-content="start">
                              <v-col cols="12"
                                     class="full-height d-flex align-center justify-center">
                                <div class="col-12 pa-0 d-flex align-center justify-center flex-wrap">
                                  <v-img src="../assets/home/sad_cow.png"
                                         class="col-12 pa-0"
                                         contain
                                         :max-width="historyExpanded ? '250px' : '150px'">
                                  </v-img>
                                  <div class="std-text-sm std-text-blue-2 col-12 pa-0 text-center mt-3"
                                       :class="{'std-text-md' : historyExpanded}">
                                    Lo sentimos, aún no hay nada por aquí :(
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                            <!-- fin de contenido de tabla -->

                            <!-- inicio de paginador -->
                            <v-row no-gutters
                                   v-if="historyExpanded && croppedHst.length !== 0"
                                   class="std-table-pagination-container px-1">
                              <v-col cols="12"
                                     class="d-flex pa-0 justify-space-between align-center">
                                <v-pagination v-model="pageSelected"
                                              :color="paginationColor"
                                              :disabled="itemsPage === 0"
                                              :length="itemsPage"
                                              :next-icon="nextIcon"
                                              :prev-icon="prevIcon"
                                              total-visible="10">
                                </v-pagination>
                                <v-select :items="pageItems"
                                          :disabled="itemsPage === 0"
                                          return-object
                                          outlined
                                          dense
                                          hide-details
                                          v-model="pageItem"
                                          value="number"
                                          item-text="formattedText">
                                </v-select>
                              </v-col>
                            </v-row>
                            <!-- fin de paginador -->

                          </v-col>
                          <!-- fin listado de eventos -->

                          <!-- inicio vacunación y desarrollo -->
                          <v-col cols="12"
                                 v-if="vaccineSelected"
                                 class="cp-vaccination-container px-3 std-background-white-1 std-border-radius std-container-shadow">

                            <!-- inicio vacunación principal -->
                            <v-row no-gutters
                                   v-if="!weightSelected"
                                   class="full-height">
                              <v-col cols="12">
                                <!-- inicio apartado desarrollo -->
                                <v-row no-gutters
                                       style="height: 196px; background-color: white">
                                  <v-col cols="12"
                                         style="height: 36px"
                                         class="pl-6 pt-6 d-flex std-text-md-open std-text-gray-3">
                                    <div class="col-4 pa-0 d-flex std-text-md align-center font-weight-bold std-text-blue-2">Desarollo</div>
                                  </v-col>
                                  <v-col cols="12"
                                         style="height: 40px"
                                         class="px-6 d-flex align-center justify-space-between">
                                    <div class="col-5 pa-0 d-flex align-center std-text-blue-2">Último peso registrado</div>
                                    <div class="col-4 pa-0 d-flex align-center std-text-blue-2 std-text-underline"
                                    style="cursor: pointer;"
                                         @click="weightSelected = true">Historial de peso</div>
                                  </v-col>
                                  <v-col cols="12"
                                         style="height: 48px"
                                         class="px-6 d-flex align-center justify-space-between">
                                    <div class="col-6 pa-0 d-flex align-center">Roberto Casablancas</div>
                                    <div class="col-2 pa-0 d-flex align-center font-weight-bold">480 KG</div>
                                    <div class="col-4 pa-0 d-flex align-center font-weight-bold">dd/mm/aaaa</div>
                                  </v-col>
                                  <v-col cols="12"
                                         style="height: 72px"
                                         class="px-6 d-flex align-center justify-start">
                                    <div class="col-5 pa-0 d-flex align-center">Proxima desparasitación</div>
                                    <div class="col-2 offset-1 pa-0 d-flex align-center font-weight-bold">480 KG</div>
                                  </v-col>
                                </v-row>
                                <!-- fin apartado desarrollo -->

                                <!-- inicio desarrollo adicional -->
                                <v-expansion-panels
                                        class="std-container-shadow-dense">
                                  <v-expansion-panel>
                                    <v-expansion-panel-header>Información de desarrollo adicional</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-row no-gutters style="height: 190px" class="std-text-sm-open std-text-gray-3">
                                        <v-col cols="12"
                                               style="height: 28px"
                                               class="d-flex justify-start align-center">
                                          <div class="col-2 pa-0 std-text-sm font-weight-bold std-text-blue-2">Peso</div>
                                        </v-col>
                                        <v-col cols="12"
                                               style="height: 24px"
                                               class="d-flex justify-start align-center ">
                                          <div class="col-5 pa-0">Peso al nacer</div>
                                          <div class="col-2 pa-0 font-weight-bold">45 kg</div>
                                        </v-col>
                                        <v-col cols="12"
                                               style="height: 24px"
                                               class="d-flex justify-start align-center">
                                          <div class="col-5 pa-0">Peso en primera inseminación</div>
                                          <div class="col-2 pa-0 font-weight-bold">360 kg</div>
                                          <div class="col-3 pa-0 font-weight-bold">dd/mm/aaaa</div>
                                        </v-col>
                                        <v-col cols="12"
                                               style="height: 24px"
                                               class="d-flex justify-start align-center">
                                          <hr style="width: 100%; text-align:left; margin-left: 0">
                                        </v-col>
                                        <v-col cols="12"
                                               style="height: 28px"
                                               class="d-flex justify-start align-center">
                                          <div class="col-2 pa-0 std-text-sm font-weight-bold std-text-blue-2">Desparasitación</div>
                                        </v-col>
                                        <v-col cols="12"
                                               style="height: 24px"
                                               class="d-flex justify-start align-center">
                                          <div class="col-5 pa-0">Frecuencia</div>
                                          <div class="col-2 pa-0 font-weight-bold">45 kg</div>
                                        </v-col>
                                        <v-col cols="12"
                                               style="height: 24px"
                                               class="d-flex justify-start align-center">
                                          <div class="col-5 pa-0">Peso en primera inseminación</div>
                                          <div class="col-2 pa-0 font-weight-bold">360 kg</div>
                                          <div class="col-3 pa-0 font-weight-bold">dd/mm/aaaa</div>
                                        </v-col>
                                      </v-row>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                                <!-- fin desarrollo adicional -->

                                <!-- inicio apartado desarrollo -->
                                <v-row no-gutters
                                       class="mt-6"
                                       style="height: 196px; background-color: white">
                                  <v-col cols="12"
                                         style="height: 36px"
                                         class="pl-6 d-flex std-text-md-open std-text-gray-3">
                                    <div class="col-4 pa-0 d-flex std-text-md align-center font-weight-bold std-text-blue-2">Vacunación</div>
                                  </v-col>
                                  <v-col cols="12"
                                         style="height: 40px"
                                         class="px-6 d-flex align-center justify-start">
                                    <div class="col-6 pa-0 d-flex align-center std-text-blue-2">Edad primera vacuna aplicada</div>
                                    <div class="col-2 pa-0 d-flex align-center justify-center font-weight-bold">90 días</div>
                                  </v-col>
                                  <v-col cols="12"
                                         style="height: 40px"
                                         class="d-flex align-center justify-space-between font-weight-bold std-text-blue-2">
                                    <div class="col-4 pa-0 pl-6 d-flex align-center ">Nombre vacuna</div>
                                    <div class="col-6 pa-0 d-flex align-center justify-center">Frecuencia</div>
                                    <div class="col-2 pa-0 d-flex align-center justify-center">Dosis</div>
                                  </v-col>
                                  <v-col cols="12"
                                         class="d-flex flex-wrap">
                                    <VaccineCard disease="Rinotraqueítis Infecciosa Bovina (IBR)"
                                                 class="mb-2"
                                                 dosis="1"
                                                 freq="Cada 6 meses">
                                    </VaccineCard>
                                    <VaccineCard disease="Diarrea viral bovina (DVR)"
                                                 class="mb-2"
                                                 dosis="0.5"
                                                 freq="Cada 12 meses">
                                    </VaccineCard>
                                    <VaccineCard disease="Derriengue (Rábia paralítica bovina)"
                                                 class="mb-2"
                                                 dosis="1"
                                                 freq="Aplicación única">
                                    </VaccineCard>
                                    <VaccineCard disease="Clostridios"
                                                 class="mb-2"
                                                 dosis="0.2"
                                                 freq="3 refuerzos uno cada 6 meses">
                                    </VaccineCard>
                                  </v-col>
                                </v-row>
                                <!-- fin apartado desarrollo -->
                              </v-col>
                            </v-row>
                            <!-- fin vacunación principal -->

                            <!-- inicio historial de peso -->
                            <v-row no-gutters
                                   v-if="weightSelected"
                                   class="full-height">
                              <v-col cols="12">
                                <!-- inicio apartado desarrollo -->
                                <v-row no-gutters
                                       style="background-color: white">
                                  <v-col cols="12"
                                         style="height: 24px"
                                         class="px-6 mt-2 mb-3 d-flex std-text-md-open std-text-gray-3 align-center">
                                    <div class="col-3 pa-0" @click="weightSelected = false">
                                      <v-row no-gutters>
                                        <v-btn class="d-flex justify-space-around std-btn-back"
                                               block
                                               color="#FFFFFF"
                                               height="24px"
                                               depressed>
                                          <div class="d-flex justify-space-between align-center std-text-xs std-text-blue-2">
                                            <i class="std-icon cp-left-small-icon mr-3"></i>
                                            Regresar
                                          </div>
                                        </v-btn>
                                      </v-row>
                                    </div>
                                    <div class="col-6 pa-0  d-flex std-text-md align-center justify-center
                                    font-weight-bold std-text-blue-2">Historial de peso</div>
                                  </v-col>
                                  <!-- inicio listado de eventos -->
                                  <v-col cols="12"
                                         class="cp-table-weight-container">

                                    <!-- inicio de header de tabla -->
                                    <v-row no-gutters
                                           class="px-1"
                                           cols="12">
                                      <div class="std-table-header d-flex align-center justify-center col-12">
                                        <div class="std-text-md-open col-5 d-flex align-center justify-center pa-0 font-weight-bold">
                                          Usuario
                                          <i class="std-vertical-arrow-icon"
                                             @click="orderBy('idInternal', idOrderFlag)"
                                             :class="{'icon-anim' : idSortedIcon}"
                                             @animationend="idSortedIcon = false">
                                          </i>
                                        </div>
                                        <div class="std-text-md-open font-weight-bold col-3 d-flex justify-center align-center pa-0">
                                          Peso (KG)
                                          <i class="std-vertical-arrow-icon"
                                             @click="orderBy('breed', breedOrderFlag)"
                                             :class="{'icon-anim' : breedSortedIcon}"
                                             @animationend="breedSortedIcon = false">
                                          </i>
                                        </div>
                                        <div class="std-text-md-open font-weight-bold col-4 d-flex justify-center align-center pa-0">
                                          Fecha
                                          <i class="std-vertical-arrow-icon"
                                             @click="orderBy('state', stateOrderFlag)"
                                             :class="{'icon-anim' : stateSortedIcon}"
                                             @animationend="stateSortedIcon = false">
                                          </i>
                                        </div>
                                      </div>
                                    </v-row>
                                    <!-- fin de header de tabla -->

                                    <!-- inicio de contenido de tabla -->
                                    <v-row no-gutters
                                           class="px-1 cp-table-rows-weight-container"
                                           align-content="start">
                                      <v-col cols="12"
                                             class="d-flex align-center justify-center std-table-row-container"
                                             v-for="(item, index) in historyNam"
                                             :key="item.id"
                                             :class="[{'first-row' : index === 0}]">
                                        <div class="col-5 align-center justify-center std-text-sm-open std-text-gray-3 pa-0 d-flex">
                                          {{item.type}}
                                        </div>
                                        <div class="col-3 d-flex align-center justify-center std-text-sm-open std-text-gray-3 pa-0">
                                          {{item.date}}
                                        </div>
                                        <!-- tercer campo -->
                                        <div class="col-4 d-flex align-center justify-center std-text-sm-open std-text-gray-3 pa-0">
                                          {{item.name}}
                                        </div>
                                      </v-col>
                                    </v-row>
                                    <!-- fin de contenido de tabla -->

                                    <!-- inicio de paginador -->
                                    <v-row no-gutters
                                           class="std-table-pagination-container px-1">
                                      <v-col cols="12"
                                             class="d-flex pa-0 justify-space-between align-center">
                                        <v-pagination v-model="pageSelected"
                                                      :color="paginationColor"
                                                      :disabled="itemsPage === 0"
                                                      :length="itemsPage"
                                                      :next-icon="nextIcon"
                                                      :prev-icon="prevIcon"
                                                      total-visible="10">
                                        </v-pagination>
                                        <v-select :items="pageItems"
                                                  :disabled="itemsPage === 0"
                                                  return-object
                                                  outlined
                                                  dense
                                                  hide-details
                                                  v-model="pageItem"
                                                  value="number"
                                                  item-text="formattedText">
                                        </v-select>
                                      </v-col>
                                    </v-row>
                                    <!-- fin de paginador -->

                                  </v-col>
                                  <!-- fin listado de eventos -->
                                </v-row>
                                <!-- fin apartado desarrollo -->
                              </v-col>
                            </v-row>
                            <!-- fin historial de peso -->

                          </v-col>
                          <!-- fin vacunación y desarrollo -->

                          <!-- inicio registro evento -->
                          <v-col cols="12" style="position: relative"
                                 v-if="vaccinesRegisytrySelected"
                                 class="cp-vaccination-registry-container px-3 std-background-white-1 std-border-radius std-container-shadow">
                                 <v-row class="d-flex pa-0" no-padding>
                                    <v-col cols="12"
                                    class="md-card-text-container pa-0 std-background-blue-2 cp-header-container std-border-top-radius std-text-white-1 d-flex align-center justify-center std-text-md font-weight-bold">
                                    Tipo de registro: Vacuna
                                    <div style="position:absolute; right: 20px"
                                    @click=""
                                    class="d-flex align-center std-pointer">
                                    <i class="std-icon cp-close-icon"></i>
                                    </div>
                                    </v-col>
                                 </v-row>
                                 <v-row class="d-flex align-center justify-start mt-3 mb-1">
                                   <v-col cols="2" offset="3" class="std-text-blue-2 mr-0 pa-0">Fecha:</v-col>
                                   <v-col cols="5" class="std-text-md std-text-gray-3 pa-0">DD/MM/AAAA</v-col>
                                 </v-row>
                                 <v-divider></v-divider>
                                 <v-row class="flex-column align-center justify-start mt-3 mb-1">
                                   <v-col cols="9" offset="3" class="std-text-blue-2 pa-0">Tipo de Evento:</v-col>
                                   <v-col cols="9" offset="3" class="std-text-md std-text-gray-3 pa-0">Enfermedades respiratorias</v-col>
                                 </v-row>
                                 <v-divider></v-divider>
                                 <v-row class="d-flex align-center justify-start mt-3 mb-1">
                                  <v-col cols="9" offset="3" class="std-text-blue-2 pa-0">Realizó registro:</v-col>
                                  <v-row class="d-flex align-center justify-start">
                                    <v-col cols="1" offset="3" class="mr-2 std-text-md std-text-gray-3 pa-0 align-center justify-center">
                                      <div class="d-flex std-background-blue-2 std-border-radius align-center justify-center" style="width: 48px; height: 48px;">
                                        <img class="std-background-blue-2 std-border-radius" style="width: 32px; height: 32px;" src="../assets/User.png" alt="" v-on="on">
                                      </div>
                                    </v-col>
                                    <v-col cols="7" class="ml-0 std-text-md std-text-gray-3 pa-0 align-center justify-start">Roberto Casablancas</v-col>
                                  </v-row>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="flex-column align-center justify-start mt-3 mb-1">
                                  <v-col cols="9" offset="3" class="std-text-blue-2 pa-0">Comentarios:</v-col>
                                  <v-col cols="9" offset="3" class="std-text-md std-text-gray-3 pa-0">La vaca se pusó rebelde</v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="flex-column align-center justify-start mt-3 mb-1">
                                  <v-col cols="9" offset="3" class="std-text-blue-2 pa-0">Recordatorios:</v-col>
                                  <v-col cols="9" offset="3" class="d-inline-flex pa-0 justify-start align-center">
                                      <div class="d-inline-flex mr-1">
                                        <i class="ds-ltl-icon ds-medical"></i></div>
                                      <div class="d-inline-flex mr-1">
                                        <i class="ds-ltl-icon ds-kpi"></i>
                                      </div>
                                      <div class="d-flex ml-1">Separar la vaca de producción por <b>5 días</b></div>
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                
                                <v-row class="cp-border ma-0 pa-0 std-background-grey-1 d-flex align-center justify-space-around"
                                       style="height: 48px; width: 100%; position: absolute; bottom: 0; left: 0">
                                  <v-col cols="4" offset="" class="align-center justify-end d-flex std-text-md std-text-blue-1 font-weight-bold pa-0">
                                    <div>Editar</div>
                                    <img style="width: 22px; height: 22px;" class="ml-2" src="../assets/Pencil_Blue.svg" alt="" v-on="on">
                                  </v-col>
                                  <v-col cols="4" offset="" class="align-center justify-start d-flex std-text-md std-text-blue-1 font-weight-bold pa-0">
                                    <div>Eliminar</div>
                                    <img style="width: 22px; height: 22px;" class="ml-2" src="../assets/Garbage_Blue.svg" alt="" v-on="on">
                                  </v-col>
                                </v-row>
                                
                          </v-col>
                          <!-- fin registro evento -->

                        </v-row>
                      </v-col>
                      <!-- fin bitácora de eventos -->

                    </v-row>
                  </v-col>
                  <!-- fin de segunda columna -->

                </v-row>
              </v-col>
            </v-row>
            <!-- fin de contenedor central -->

          </v-col>
          <!-- inicio de contenedor principal -->
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import SystemCardCount from "../components/SystemCardCount";
    import moment from 'moment'
    import Alerts from "./Alerts";
    import VaccineCard from "../components/VaccineCard";
    import BackButton from "../components/BackButton";
    import { EventBus } from './bus.js';
    import { mapGetters } from 'vuex'

    export default {
        name: 'CowProfile',
        props: ['type', 'id'],
        data () {
            return {
                dialogHst: false, // shows the dialog of history items
                groupSelected: '',
                listSelected: true,
                weightSelected: false,
                vaccineSelected: false,
                vaccineRegistrySelected: false,
                historyType: 'events',
                events: 4,
                hstToShow: {},
                flagDevelopment: false,
                page: 1,
                pageItem: {number: 10, formattedText: '10 eventos por hoja'},
                pageItems: [
                    {number: 10, formattedText: '10 eventos por hoja'},
                    {number: 20, formattedText: '20 eventos por hoja'},
                    {number: 30, formattedText: '30 eventos por hoja'},
                    {number: 40, formattedText: '40 eventos por hoja'},
                ],
                hst: [], // history of animal
                pageSelected: 1,
                nextIcon: 'navigate_next',
                prevIcon: 'navigate_before',
                heatSw: true,
                htNtn: false,
                ptNtn: false,
                hlNtn: false,
                btNtn: false,
                htCheck: false,
                ptCheck: false,
                birthSwDisabled: false,
                snackActive: false,
                /*heatOn: this.$store.getters.getCurrentAnimal.isInHeat,
                pregnantOn: false,*/
                activeSick:false,
                activeBirth:false,
                activeGestation:false,
                snackText: '',
                tpOrderFlag: false,
                dtOrderFlag: false,
                evOrderFlag: false,
                tpSortedIcon: false,
                dtSortedIcon: false,
                evSortedIcon: false,
                historyNam: [
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado y ahora es ","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSws"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwad"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwzxc"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwzxcz"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwasd"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwwef"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwgg"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwdsf"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwsfsd"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwsdfs"},
                    {"date":"2020-01-09","description":"¡Nuevo animal en el rancho!","name":"Animal agregado","type":"newAnimal","key":"nOhXnKtqcTuSlJH7IJSwsddddfs"},
                ],
                animalFire: null,
                evtKeyDel: '',
                historyExpanded: false,
                openRadio: false,
                tmpPaddock: null,
            }
        },
        components: {
            BackButton,
            SystemCardCount,
            VaccineCard,
            Alerts
        },
        watch: {
            animalsPerPage() {
                this.pageSelected = 1;
            },
            animalsFire(newVal) {
              this.animalFire = newVal.find(cow => cow.key === this.id);
            },
        },
        computed: {
            ...mapGetters(["getHistory", "paddocks"]),
            paddock: {
                // getter
                get: function () {
                    return this.animalFire.paddock;
                },
                // setter
                set: function (newValue) {
                    this.tmpPaddock = newValue;
                }
            },
            cowCount() {
                return this.$store.getters.getCows.length;
            },
            htToolText() {
                if (this.ptCheck) {
                    return '¡Espera la alerta de parto!';
                } else if (this.htNtn) {
                    return '¡Tienes una alerta de celo!';
                } else {
                    return '¿Quieres añadir un celo?';
                }
            },
            ptToolText() {
                if (this.ptCheck) {
                    return '¡Espera la alerta de parto!';
                } else if (this.ptNtn) {
                    return '¡Tienes una alerta de preñado!';
                } else {
                    return "¿Quieres confirmar la preñez?";
                }
            },
            btToolText() {
                if (this.btNtn) {
                    return '¡Tienes una alerta de parto!';
                } else {
                    return '¿Quieres confirmar un parto?';
                }
            },
            animalsFire() {
              return this.$store.getters.getCows;
            },
            /**
             * Regresa el número de animales que se mostrarán por página
             */
            animalsPerPage() {
                return this.pageItem.number;
            },
            /**
             * Texto del campo expandir / reducir bitácora
             */
            historyResizeTitle() {
                if (this.historyExpanded) {
                    return "Reducir bitácora";
                }
                return "Expandir bitácora" ;
            },
            /**
             * Calcula el número de páginas que mostrará la paginación
             */
            itemsPage() {
                return Math.floor(this.historyNam.length / this.pageItem.number) + 1;
            },
            /**
             * Regresa los elementos de la bitácora de acuerdo a los eventos
             * por hoja seleccionados por el usuario
             */
            croppedHst() {
                let hst = this.$store.getters.getHistory;
                if (hst !== undefined) {
                    return hst.slice((this.pageSelected - 1) * this.pageItem.number, this.pageSelected * this.pageItem.number);
                } else {
                    return null;
                }
            },
            /**
             * Regresa el ciclo de lactancia del animal
             */
            lactationCycle () {
                return this.$store.getters.getCurrentAnimal.lactationCycle;
            },
            /**
             * Regresa el tamaño de elementos guardados en history
             */
            historyItems() {
                return 10;
                // return this.$store.getters.getCurrentAnimal.history.length;
            },
            /**
             * Regresa el animal actual para realizar cambios
             */
            currentAnimal() {
                return this.$store.getters.getCurrentAnimal;
            },
            pregnantAlertConfirmed() {
                return this.$store.getters.getCurrentAnimal.pregnantDate !== null;
            },
            /**
             * Regresa el grupo actual del animal seleccionado
             * @returns {*}
             */
            group() {
                return this.$store.getters.getCurrentAnimal.group;
            },
            userData() {
                return this.$store.getters.getUserData
            },
            animals() {
                return this.$store.getters.getAnimals;
            },

            groups() {
                return this.$store.getters.cowGroups;
            },
            numberOfAnimals() {
                if(this.$store.getters.getAnimals.length < 10){
                    return "00"+this.$store.getters.getAnimals.length;
                } else if(this.$store.getters.getAnimals.length < 100){
                    return "0"+this.$store.getters.getAnimals.length;
                } else if(this.$store.getters.getAnimals.length >= 100){
                    return this.$store.getters.getAnimals.length;
                }
                return 0;
            },
        },
        methods: {
          back() {
            this.$router.go(-1);
          },
            showHstItem(item) {
                this.dialogHst = true;
                this.hstToShow.name = item.name;
                this.hstToShow.description = item.description;
                this.hstToShow.date = item.date;
                this.hstToShow.type = item.type;
            },
            idResized(id) {
                return id.slice(0, 8);
            },
            /**
             * Delete a history item and the data
             */
            deleteHstItem() {
                let item = this.$store.getters.getHistory.find(event => event.key === this.evtKeyDel);
                let payload = {
                    animalKey: this.id,
                    hstKey: item.key,
                }
                switch (item.type) {
                    case 'heat':
                        payload.heatKey = item.heatKey;
                        payload.type = 'heat';
                        this.snackText = "¡Eliminando celo!"
                        this.snackActive = true;
                        this.$store.dispatch('deleteHstHeat', payload);
                        break;
                    case 'preg':
                        payload.type = 'preg';
                        payload.actualPreg = this.$store.getters.getCows.find(cow => cow.key === this.id).pregDate === item.date;
                        this.snackText = "¡Eliminando preñado!"
                        this.snackActive = true;
                        this.$store.dispatch('deleteHstHeat', payload);
                        break;
                    case 'health':
                        payload.type = 'health';
                        this.snackText = "¡Eliminando salud!"
                        this.snackActive = true;
                        this.$store.dispatch('deleteHstHeat', payload);
                        break;
                    default:
                        break;
                }
            },
            /**
             * Ordena los animales según los parámetros dados
             * @param itemToSort la categoría a ordenar
             * @param ascend indica la ordenación, si es ascendente o descendente
             */
            orderBy(itemToSort, ascend){
                console.log(ascend);
                switch (itemToSort) {
                    case 'type':
                        this.tpOrderFlag = !this.tpOrderFlag;
                        this.tpSortedIcon = true;
                        break;
                    case 'date':
                        this.dtOrderFlag = !this.dtOrderFlag;
                        this.dtSortedIcon = true;
                        break;
                    case 'description':
                        this.evOrderFlag = !this.evOrderFlag;
                        this.evSortedIcon = true;
                        break;
                }

               /* if (!ascend) {
                    this.animalsToRender = this.animalsToRender.sort((a, b) => {
                        if (a[itemToSort] > b[itemToSort]) {
                            return 1;
                        } else if (a[itemToSort] < b[itemToSort]) {
                            return -1;
                        } else {
                            return 0;
                        }
                    });
                } else {
                    this.animalsToRender = this.animalsToRender.sort((a, b) => {
                        if (a[itemToSort] > b[itemToSort]) {
                            return -1;
                        } else if (a[itemToSort] < b[itemToSort]) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }*/
            },
            /**
             * Expande la bitácora y regresa la vista al
             * listado de eventos
             */
            resizeHistory() {
                this.historyExpanded = !this.historyExpanded;
                this.eventsOn();
            },
            vaccinesOn() {
                this.listSelected = false;
                this.vaccineSelected = true;
                this.vaccinesRegisytrySelected = false;
            },
            eventsOn() {
                this.listSelected = true;
                this.vaccineSelected = false;
                this.weightSelected = false;
                this.vaccinesRegisytrySelected = false;
            },
            vaccinesRegistryOn() {
                this.listSelected = false;
                this.vaccineSelected = false;
                this.weightSelected = false;
                this.vaccinesRegisytrySelected = true;
            },
            /**
             * Regresa un string con una fecha en formato
             * @param date la fecha a aplicarle el formato
             * @returns {string}
             */
            formattedDate(date) {
                return moment(date).format('DD[.]MMMM[.]YYYY');
            },
            getEventType(type) {
                let result = '';
                switch (type) {
                    case 'heat':
                        result = 'Celo';
                        break;
                    case 'preg':
                        result = 'Preñado';
                        break;
                    case 'health':
                        result = 'Salud';
                        break;
                    case 'newAnimal':
                        result = 'Sistema';
                        break;
                    case 'birth':
                        result = 'Parto';
                        break;
                    default:
                        result = 'Alerta general';
                        break;
                }
                return result;
            },
            openSpecificAlert(type, key = null) {
                switch(type) {
                    case 'Heat':
                        if (!this.htCheck) {
                            this.snackText = "Guardado evento de celo";
                            EventBus.$emit('changeAlertType', type);
                        }
                        break;
                    case 'Gestation':
                        if (!this.ptCheck) {
                            this.snackText = "Guardado evento de preñado";
                            EventBus.$emit('changeAlertType', type);
                        }
                        break;
                    case 'Birth':
                        if (this.ptCheck) {
                            this.snackText = "Guardado nacimiento";
                            EventBus.$emit('changeAlertType', type);
                        }
                        this.snackText = "Guardado nacimiento";
                        EventBus.$emit('changeAlertType', type);
                        break;
                    case 'Health':
                        this.snackText = "Guardado evento de salud";
                        EventBus.$emit('changeAlertType', type);
                        break;
                    case 'Delete':
                        this.snackText = "Eliminando animal";
                        EventBus.$emit('changeAlertType', type);
                        break;
                    case 'evt':
                        this.snackText = "¡Eliminando evento!";
                        this.evtKeyDel = key;
                        EventBus.$emit('changeAlertType', type);
                        break;
                    default:
                        break;

                }


            },
            goBackOne(){
                this.$router.go(-1)
            },
            setPaddock() {
                this.$store.dispatch("setAnmPaddock", {key: this.id, paddock: this.tmpPaddock});
            }
        },
        created() {

            EventBus.$on('closeAlerts', () => {
                this.activeSick = false;
                this.activeBirth = false;
                this.activeGestation = false;
                this.heatSw = false;
            });

            // changed some properties if the event flux has been uncompleted
            EventBus.$on('evntIncomplete', (evntCancel) => {
                switch (evntCancel.evnt) {
                    case 'ht':
                        this.htNtn = evntCancel.ntn;
                        break;
                    case 'pt':
                        this.ptNtn = evntCancel.ntn;
                        break;
                }
            });

            // desactiva el switch de preñado
            EventBus.$on('pregCompleted', (preg) => {
                this.ptNtn = false;
                if (preg) {
                    this.ptCheck = true;
                }
            });


            EventBus.$on('evtDelete', () => {
                this.deleteHstItem();
            });

        },
        mounted() {
          this.$store.dispatch('listenHistory', {type: 'cows', key: this.id});
          let tmp = null;

          if (this.type === 'heifers') {
            tmp = this.$store.getters.getHeifers.find(heifer => heifer.key === this.id);
          } else {
            tmp = this.$store.getters.getCows.find(cow => cow.key === this.id);
          }
            this.htNtn = tmp.inHeat === 'pending';
            this.ptNtn = tmp.ptNtn !== null;
            this.btNtn = tmp.btNtn !== null;
            this.hlNtn = tmp.health;

            this.ptCheck = tmp.pregDate !== null;

            if (this.btNtn || tmp.pregDate !== null) {
                this.htNtn = false;
                this.ptNtn = false;
                this.ptCheck = true;
            }

            EventBus.$on('hideEvntSnack', () => {

                this.snackActive = false;
            });

            EventBus.$on('showEvntSnack', () => {
                this.snackActive = true;
            });


            this.animalFire = tmp;
        }
    };
</script>

<style lang="css">
  @import '../style/CowProfile.css';
</style>
